import ButtonData from './ButtonData';

export const Keys = {
  GOOGLE_TRACKING_ID: (process.env.NODE_ENV === 'production') ? 'UA-188547943-2' : 'UA-188547943-3',
}

export function labelFromBogusChoice(choice) {
  let noteInfo = this.choice.match(/^(\w)(\d)(.*)/);
  let note = noteInfo[1];
  let register = noteInfo[2];
  let accidental = noteInfo[3];
  if (accidental === 'flat') {
    note = note + String.fromCharCode(0x266d)
  }
  if (accidental === 'sharp') {
    note = note + String.fromCharCode(0x266f)
  }
  const label = note + register
  return label
}

export function shuffle(choices) {
  choices.forEach((val, key) => {
    let randomIndex = Math.ceil(Math.random()*(key + 1));
    choices[key] = choices[randomIndex];
    choices[randomIndex] = val;
  });
  return choices.filter(e => e != null);
}

export function choiceButtonData(bogusChoices, correctAnswer) {
  const bogusChoiceList = bogusChoices.split(' ');
  const choices = [
    new ButtonData({choice:bogusChoiceList[0]}),
    new ButtonData({choice:bogusChoiceList[1]}),
    new ButtonData({choice:bogusChoiceList[2]}),
    new ButtonData({choice:correctAnswer}),
  ];
  const shuffled = shuffle(choices);
  const buttonData = [
    { choice: shuffled[0].choice, label: shuffled[0].label },
    { choice: shuffled[1].choice, label: shuffled[1].label },
    { choice: shuffled[2].choice, label: shuffled[2].label },
    { choice: shuffled[3].choice, label: shuffled[3].label },
  ];
  return buttonData;
}

export function choiceToLabel(choice) {
    let noteInfo = choice.match(/^(\w)(\d)(.*)/);
    let note = noteInfo[1];
    let register = noteInfo[2];
    let accidental = noteInfo[3];
    if (accidental === 'flat') {
      note = note + String.fromCharCode(0x266d);
    }
    if (accidental === 'sharp') {
      note = note + String.fromCharCode(0x266f);
    }
    const label = note + register;
    return label;
}

